import { createFileRoute } from '@tanstack/react-router';

// DefaultModuleRedirector uses document.location.replace() — keep as-is
import DefaultModuleRedirector from '../../DefaultModuleRedirector';

export const Route = createFileRoute('/_secured/')({
  component: DefaultModuleRedirector,
});
